import { Paquete } from '../types/catalogo';

/**
 * Validaciones espejo de UX (Functional Design, business-rules.md) — el backend
 * SIEMPRE re-valida; estas funciones solo dan feedback inmediato en el formulario.
 */

/** FR-CAT-01 (espejo de BR-CAT-01): stock entero >= 0. */
export function validarStock(stock: number): string | null {
  if (!Number.isInteger(stock) || stock < 0) {
    return 'El stock debe ser un número entero mayor o igual a 0';
  }
  return null;
}

/** FR-CAT-02 (espejo de BR-CAT-02): paquete con nombre, cantidad y precio válidos. */
export function validarPaquete(paquete: Pick<Paquete, 'nombre' | 'cantidadEnUnidades' | 'precio'>): string | null {
  if (!paquete.nombre || paquete.nombre.trim().length === 0) {
    return 'El paquete debe tener un nombre';
  }
  if (!Number.isInteger(paquete.cantidadEnUnidades) || paquete.cantidadEnUnidades <= 0) {
    return 'La cantidad debe ser un entero mayor a 0';
  }
  if (!(paquete.precio > 0)) {
    return 'El precio debe ser mayor a 0';
  }
  return null;
}

/** FR-CAT-03 (espejo de BR-CAT-03): nombres de paquete únicos dentro del producto. */
export function tieneNombresDuplicados(paquetes: Array<Pick<Paquete, 'nombre'>>): boolean {
  const nombres = paquetes.map((p) => p.nombre.trim().toLowerCase()).filter(Boolean);
  return new Set(nombres).size !== nombres.length;
}

/** FR-CART-01 (espejo de BR-CART-01): cantidad de paquetes entera > 0. */
export function validarCantidadDePaquetes(cantidad: number): string | null {
  if (!Number.isInteger(cantidad) || cantidad <= 0) {
    return 'La cantidad debe ser un entero mayor a 0';
  }
  return null;
}

/** FR-ORD-01: nombre y teléfono requeridos para el checkout. */
export function validarContacto(nombre: string, telefono: string): { nombre?: string; telefono?: string } {
  const errores: { nombre?: string; telefono?: string } = {};
  if (!nombre || nombre.trim().length === 0) {
    errores.nombre = 'El nombre es requerido';
  }
  if (!telefono || !/^\d{7,}$/.test(telefono.replace(/\s+/g, ''))) {
    errores.telefono = 'Ingresa un teléfono válido (mínimo 7 dígitos)';
  }
  return errores;
}

/** FR-ID-01: usuario y contraseña requeridos para el login. */
export function validarLogin(usuario: string, password: string): { usuario?: string; password?: string } {
  const errores: { usuario?: string; password?: string } = {};
  if (!usuario || usuario.trim().length === 0) errores.usuario = 'El usuario es requerido';
  if (!password || password.length === 0) errores.password = 'La contraseña es requerida';
  return errores;
}
